/* eslint-disable no-unused-vars */
import { isEmpty, find, get } from 'lodash';
import tmsApi from './../../api/tmsApi';
import helper from './../helper';

const { createInputParam } = helper;

export default {
  namespaced: true,
  state: {
    dataState: {
      shipments: 'LOADING',
      shipmentDetail: 'LOADING',
      shipmentOrders: 'LOADING',
      shipmentsSummary: 'LOADING',
      shipmentSummary: 'LOADING',
    },
    orders: [],
    shipments: [],
    locations: [],
    vehicles: [],
    loaders: [],
    drivers: [],
    shipments_result: [],
    shipments_result_count: 0,
    detailData: null,
    detailDataId: null,
    detailLoaded: false,
    dataLoaded: false,
    completionColumn: 1,
    count_info: {
      all: 0,
      created: 0,
      on_process: 0,
      finish: 0,
    },
    query: {
      search: '',
      company_id: null,
      origin_id: null,
      vehicle_id: null,
      confirmation_filter_or: null,
      state_filter_or: [],
      page: {
        lastData: null,
        count: 10,
      },
      sort: {
        by: 'CREATED_AT',
        direction: 'DESC',
      },
      type: null,
      active: 'all',
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.shipments.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      data.origin = data.origin || {};
      data.vehicle = data.vehicle || {
        company: {},
        driver: {},
      };
      data.metadata = data.metadata || {};
      if (typeof find(state.shipments, { id: data.id }) !== 'object') {
        state.shipments.push(data);
      }
    },
    CLEAR_ORDER_DATA(state) {
      state.orders.splice(0);
    },
    ADD_ORDER_DATA_ON_LIST(state, data) {
      if (!data.metadata) {
        data.metadata = {};
        data.metadata.time_in = '';
        data.metadata.time_out = '';
      }
      if (typeof find(state.orders, { id: data.id }) !== 'object') {
        state.orders.push(data);
      }
    },
    CLEAR_QUERY({ query }) {
      query.search = '';
      query.company_id = null;
      query.origin_id = null;
      query.vehicle_id = null;
      query.confirmation_filter_or = [];
      query.state_filter_or = [];
      query.page.lastData = null;
      query.page.count = 10;
      query.sort.by = 'ID';
      query.sort.direction = 'DESC';
    },
    ADD_LOCATIONS_DATA(state, data) {
      state.locations = data;
    },
    ADD_VEHICLE_DATA(state, data) {
      state.vehicles = data;
    },
    ADD_LOADERS_DATA(state, data) {
      state.loaders = data;
    },
    ADD_DRIVERS_DATA(state, data) {
      state.drivers = data;
    },
    SET_COMPANY_ID(state, id) {
      state.query.company_id = id;
    },
    SET_ORIGIN_ID(state, id) {
      state.query.origin_id = id;
    },
    SET_VEHICLE_ID(state, id) {
      state.query.vehicle_id = id;
    },
    SET_CONFIRMATION_FILTER(state, confirmations) {
      state.query.confirmation_filter_or.splice(0);
      confirmations.forEach((confirmation) => {
        state.query.confirmation_filter_or.push(confirmation);
      });
    },
    SET_STATE_FILTER(state, states) {
      state.query.state_filter_or.splice(0);
      states.forEach((stateType) => {
        state.query.state_filter_or.push(stateType);
      });
    },
    SET_QUERY_SEARCH(state, search) {
      state.query.search = search;
    },
    SET_QUERY_PAGE(state, number) {
      state.query.page.number = number;
    },
    SET_QUERY_COUNT(state, count) {
      state.query.page.count = count;
    },
    SET_QUERY_SORT(state, sort) {
      const [by, direction] = sort.split('.');
      state.query.sort.direction = direction;
      state.query.sort.by = by;
    },
    SET_COUNT_INFO(state, info) {
      state.count_info.all = 0;
      state.count_info.created = 0;
      state.count_info.on_process = 0;
      state.count_info.finish = 0;
      info.forEach((c) => {
        state.count_info.all += c.count;
        if (c.state === 'CREATED') {
          state.count_info.created += c.count;
        } else if (c.state === 'ON PROCESS') {
          state.count_info.on_process += c.count;
        } else if (c.state === 'FINISH') {
          state.count_info.finish += c.count;
        }
      }, this);
    },
    SET_DETAIL_NOT_LOADED(state) {
      state.detailLoaded = false;
    },
    SET_DETAIL_LOADED(state) {
      state.detailLoaded = true;
    },
    SET_DETAIL_ID(state, id) {
      state.detailDataId = id;
    },
    SET_DETAIL_DATA(state, data) {
      state.detailData = data;
    },
    SET_QUERY_LAST_DATA({ query }, data) {
      query.page.lastData = data;
    },
    DELETE_DETAIL_DATA(state, id) {
      const index = state.shipments.findIndex(shipment => shipment.id === id);
      state.shipments.splice(index, 1);
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
    SET_DATA_LOADED(state) {
      state.dataLoaded = true;
    },
    SET_DATA_NOT_LOADED(state) {
      state.dataLoaded = false;
    },
    SET_DATA_JOBS_LOADED(state) {
      state.dataLoaded = true;
    },
    SET_DATA_JOBS_NOT_LOADED(state) {
      state.dataLoaded = false;
    },
    CLEAR_SHIPMENTS_RESULT_DATA(state) {
      state.shipments_result.splice(0);
    },
    ADD_SHIPMENTS_RESULT(state, data) {
      state.shipments_result.push(data);
    },
    SET_SHIPMENTS_RESULT_COUNT(state, data) {
      state.shipments_result_count = data;
    },
    SET_COULMN_COMPLETION(state, count) {
      state.completionColumn = count;
    },
    SET_DATA_STATE_SHIPMENTS({ dataState }, state) {
      dataState.shipments = state;
    },
    SET_DATA_STATE_SHIPMENT_DETAIL({ dataState }, state) {
      dataState.shipmentDetail = state;
    },
    SET_DATA_STATE_SHIPMENT_ORDERS({ dataState }, state) {
      dataState.shipmentOrders = state;
    },
    SET_DATA_STATE_SHIPMENTS_SUMMARY({ dataState }, state) {
      dataState.shipmentsSummary = state;
    },
    SET_DATA_STATE_SHIPMENT_SUMMARY({ dataState }, state) {
      dataState.shipmentSummary = state;
    },
  },
  getters: {
    shipments(state) {
      return state.shipments;
    },
    orders(state) {
      return state.orders;
    },
    locations(state) {
      return state.locations;
    },
    vehicles(state) {
      return state.vehicles;
    },
    loaders(state) {
      return state.loaders;
    },
    drivers(state) {
      return state.drivers;
    },
    count_all(state) {
      return state.count_info.all;
    },
    count_created(state) {
      return state.count_info.created;
    },
    count_on_process(state) {
      return state.count_info.on_process;
    },
    count_finish(state) {
      return state.count_info.finish;
    },
    get_detail_data(state) {
      return state.detailData || {};
    },
    detailLoaded(state) {
      return state.detailLoaded;
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },
    dataShipmentsResult(state) {
      return state.shipments_result;
    },
    dataShipmentsResultCount(state) {
      return state.shipments_result_count;
    },
    completion_column(state) {
      return state.completionColumn;
    },
    dataStateShipments(state) {
      return state.dataState.shipments;
    },
    dataStateShipmentDetail(state) {
      return state.dataState.shipmentDetail;
    },
    dataStateShipmentOrders(state) {
      return state.dataState.shipmentOrders;
    },
    dataStateShipmentsSummary(state) {
      return state.dataState.shipmentsSummary;
    },
    dataStateShipmentSummary(state) {
      return state.dataState.shipmentSummary;
    },
  },
  actions: {
    LOAD_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { count, lastData } = state.query.page;
      const { by, direction } = state.query.sort;
      const limit = count;
      const companyId = createInputParam(state.query, 'company_id', false);
      const originId = createInputParam(state.query, 'origin_id', false);
      const vehicleId = createInputParam(state.query, 'vehicle_id', false);
      const stateFilter = state.query.state_filter_or;
      const confirmFilter = state.query.confirmation_filter_or;
      let after = '';
      let before = '';

      const stateValue = !isEmpty(stateFilter) ?
        `state_filter_or: [${stateFilter.join(', ')}]` : '';
      const confirmationValue = !isEmpty(confirmFilter) ?
        `confirmation_filter_or: [${confirmFilter.join(', ')}]` : '';
      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      let skip = '';
      if (lastData !== null) {
        skip = `
          skip: {
            by: ID
            ${after}
            ${before}
          },
        `;
      }
      const query = `
        {
          shipments(
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${skip}
            ${companyId}
            ${originId}
            ${vehicleId}
            ${confirmationValue}
            ${stateValue}
          ) {
            id
            number
            type
            state
            metadata
            created_at
            updated_at
            external_id
            delivery_date
            driver {
              id
              name
            }
            origin {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
              metadata
            }
            vehicle {
              id
              reg_no
              company {
                id
                name
              }
              driver {
                id
                name
              }
              groups {
                id
                name
                description
              }
            }
            driver {
              id
              name
            }
            confirmations {
              key
              name
              created_at
            }
          }
        }
      `;
      commit('CLEAR_DATA');
      // commit('SET_DATA_NOT_LOADED');
      commit('SET_DATA_STATE_SHIPMENTS', 'LOADING');
      return api(query, 'shipmentslist').then(({ data }) => {
        const { shipments } = data;
        if (!isEmpty(shipments)) {
          shipments.forEach((shipment) => {
            commit('ADD_DATA_ON_LIST', shipment);
          }, this);
        }
      }).then(() => {
        setTimeout(() => commit('SET_DATA_STATE_SHIPMENTS', 'LOADED'), 50);
      }).catch(() => {
        commit('SET_DATA_STATE_SHIPMENTS', 'ERROR');
      });
    },
    LOAD_INFO({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const query = `
        {
          shipment_info(query: "${state.query.search}") {
            state
            count
          }
        }
      `;
      commit('CLEAR_DATA');
      return api(query, 'shipment_info').then(({ data }) => {
        const { shipment_info } = data;
        commit('SET_COUNT_INFO', shipment_info);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_INFO');
      });
    },
    LOAD_SUMMARY({ state, rootState, commit }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { count, lastData } = state.query.page;
      const { by, direction } = state.query.sort;
      const limit = count;
      const companyId = createInputParam(state.query, 'company_id', false);
      const originId = createInputParam(state.query, 'origin_id', false);
      const vehicleId = createInputParam(state.query, 'vehicle_id', false);
      const stateFilter = state.query.state_filter_or;
      const confirmFilter = state.query.confirmation_filter_or;
      let after = '';
      let before = '';

      const stateValue = !isEmpty(stateFilter) ?
        `state_filter_or: [${stateFilter.join(', ')}]` : '';
      const confirmationValue = !isEmpty(confirmFilter) ?
        `confirmation_filter_or: [${confirmFilter.join(', ')}]` : '';
      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      let skip = '';
      if (lastData !== null) {
        skip = `
          skip: {
            by: NUMBER
            ${after}
            ${before}
          },
        `;
      }
      const query = `
        {
          summary: shipments_summary(
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${skip}
            ${companyId}
            ${originId}
            ${vehicleId}
            ${confirmationValue}
            ${stateValue}
          ) {
            id
            number
            origin {
              id
              code
              name
              metadata
            }
            company {
              id
              name
            }
            vehicle {
              id
              reg_no
              company {
                id
                name
              }
              driver {
                id
                name
              }
              gps_devices {
                id
                gps_info {
                  id
                  longitude
                  latitude
                  road_name
                }
              }
            }
            driver {
              id
              name
            }
            destinations {
              name
              address
              percentage
              finish
              total_order
              direction {
                id
                distance
                duration
                metadata
              }
              orders {
                id
                number
                sequence
                status
                metadata
                created_at
                customer {
                  id
                  name
                  address {
                    id
                    city
                  }
                }
                units {
                  number
                  type
                }
              }
            }
            total_percentage
            updated_at
          }
        }
      `;
      return api(query, 'shipments_summary').then(({ data }) => {
        const { summary } = data;
        return summary;
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_SUMMARY');
      });
    },
    LOAD_DATA_COMPLETION({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { count, lastData } = state.query.page;
      const { by, direction } = state.query.sort;
      const limit = count;
      const companyId = createInputParam(state.query, 'company_id', false);
      const stateFilter = state.query.state_filter_or;
      let after = '';
      let before = '';
      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      let skip = '';
      if (lastData !== null) {
        skip = `
          skip: {
            by: NUMBER
            ${after}
            ${before}
          },
        `;
      }
      const stateValue = !isEmpty(stateFilter) ?
        `state_filter_or: [${stateFilter.join(', ')}]` : '';

      const query = `
        {
          shipments(
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${skip}
            ${companyId}
            ${stateValue}
          ) {
            id
            number
            company {
              id
              name
            }
            origin {
              id
              code
              name
              metadata
            }
            vehicle {
              id
              reg_no
              company {
                id
                name
              }
              driver {
                id
                name
              }
            }
            driver {
              id
              name
            }
            orders {
              id
              sequence
              metadata
              number
              units {
                id
                number
                type
              }
              invoice {
                id
                number
              }
              customer {
                id
                name
                address {
                  id
                  city
                }
              }
              destination {
                id
                code
                name
                metadata
              }
              created_at
            }
            created_at
          }
        }
      `;
      commit('CLEAR_DATA');
      return api(query, 'load_completions').then(({ data }) => {
        const { shipments } = data;
        shipments.forEach((shipment) => {
          commit('ADD_DATA_ON_LIST', shipment);
        }, this);
        return shipments;
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DATA_COMPLETION');
      });
    },
    FIND_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { count, lastData } = state.query.page;
      const { by, direction } = state.query.sort;
      const limit = count;
      const companyId = state.query.company_id === null
        ? '' : `company_id: ${state.query.company_id}`;
      let after = '';
      let before = '';
      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      let skip = '';
      if (lastData !== null) {
        skip = `
          skip: {
            by: NUMBER
            ${after}
            ${before}
          },
        `;
      }
      const query = `
        {
          shipments: find_shipments(
            query: "${state.query.search}",
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${skip}
            ${companyId}
          ) {
            id
            number
            type
            state
            metadata
            created_at
            updated_at
            external_id
            origin {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
              metadata
            }
            vehicle {
              id
              reg_no
              company {
                id
                name
              }
              driver {
                id
                name
              }
            }
            driver {
              id
              name
            }
            confirmations {
              key
              name
              created_at
            }
          }
        }
      `;
      commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      return api(query).then(({ data }) => {
        const { shipments } = data;
        shipments.forEach((shipment) => {
          commit('ADD_DATA_ON_LIST', shipment);
        }, this);
      }).then(() => {
        setTimeout(() => commit('SET_DATA_LOADED'), 1e3);
      }).catch(() => {
        commit('ADD_ERROR', 'FIND_DATA');
      });
    },
    FIND_DATA_SUMMARY({ state, rootState, commit }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { count, lastData } = state.query.page;
      const { by, direction } = state.query.sort;
      const limit = count;
      const companyId = state.query.company_id === null
        ? '' : `company_id: ${state.query.company_id}`;
      let after = '';
      let before = '';
      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      let skip = '';
      if (lastData !== null) {
        skip = `
          skip: {
            by: NUMBER
            ${after}
            ${before}
          },
        `;
      }
      const query = `
        {
          shipments: find_shipments_summary(
            query: "${state.query.search}",
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${skip}
            ${companyId}
          ) {
            id
            number
            origin {
              id
              code
              name
              metadata
            }
            company {
              id
              name
            }
            vehicle {
              id
              reg_no
              company {
                id
                name
              }
              driver {
                id
                name
              }
              gps_devices {
                id
                gps_info {
                  id
                  longitude
                  latitude
                  road_name
                }
              }
            }
            driver {
              id
              name
            }
            destinations {
              name
              address
              percentage
              finish
              total_order
              direction {
                id
                distance
                duration
                metadata
              }
              orders {
                id
                number
                sequence
                status
                metadata
                created_at
                customer {
                  id
                  name
                  address {
                    id
                    city
                  }
                }
                units {
                  number
                  type
                }
              }
            }
            total_percentage
          }
        }
      `;
      return api(query).then(({ data }) => {
        const { shipments } = data;
        return shipments;
      }).catch(() => {
        commit('ADD_ERROR', 'FIND_DATA_SUMMARY');
      });
    },
    FIND_DATA_COMPLETION({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { count, lastData } = state.query.page;
      const { by, direction } = state.query.sort;
      const limit = count;
      const companyId = state.query.company_id === null
        ? '' : `company_id: ${state.query.company_id}`;
      let after = '';
      let before = '';
      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      let skip = '';
      if (lastData !== null) {
        skip = `
          skip: {
            by: NUMBER
            ${after}
            ${before}
          },
        `;
      }
      const query = `
        {
          shipments: find_shipments(
            query: "${state.query.search}",
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${skip}
            ${companyId}
          ) {
            id
            number
            company {
              id
              name
            }
            origin {
              id
              code
              name
            }
            vehicle {
              id
              reg_no
              company {
                id
                name
              }
              driver {
                id
                name
              }
            }
            orders {
              id
              sequence
              metadata
              number
              units {
                id
                number
                type
              }
              invoice {
                id
                number
              }
              customer {
                id
                name
                address {
                  id
                  city
                }
              }
              destination {
                id
                code
                name
                metadata
              }
              created_at
            }
          }
        }
      `;
      commit('CLEAR_DATA');
      return api(query).then(({ data }) => {
        const { shipments } = data;
        shipments.forEach((shipment) => {
          commit('ADD_DATA_ON_LIST', shipment);
        }, this);
      }).catch(() => {
        commit('ADD_ERROR', 'FIND_DATA_COMPLETION');
      });
    },
    LOAD_DETAIL_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const query = `
        {
          shipment(id: ${state.detailDataId}) {
            id
            number
            state
            type
            metadata
            created_at
            updated_at
            external_id
            delivery_date
            company {
              id
              name
            }
            origin {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
              metadata
              company {
                id
                name
              }
            }
            vehicle {
              id
              reg_no
              company {
                name
              }
              driver {
                name
              }
            }
            driver {
              id
              name
            }
            orders {
              id
              number
              customer {
                id
                name
              }
              destination {
                id
                name
                geometry {
                  type
                  coordinates
                }
              }
              direction {
                geo_poly {
                  type
                  coordinates
                }
              }
            }
            confirmations {
              key
              name
              created_at
              signature
              metadata
            }
          }
        }
      `;
      commit('SET_DETAIL_NOT_LOADED');
      return api(query, 'shipment').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.shipment);
        commit('SET_DETAIL_LOADED');
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DETAIL_DATA');
      });
    },
    LOAD_DETAIL_DATA_SUMMARY({ state, rootState, commit }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const query = `
        {
          shipment: shipment_summary(id: ${state.detailDataId}) {
            id
            number
            origin {
              id
              code
              name
              metadata
            }
            company {
              id
              name
            }
            vehicle {
              id
              reg_no
              company {
                id
                name
              }
              driver {
                id
                name
              }
              gps_devices {
                id
                gps_info {
                  id
                  longitude
                  latitude
                  road_name
                }
              }
            }
            driver {
              id
              name
            }
            destinations {
              name
              address
              percentage
              finish
              total_order
              direction {
                id
                distance
                duration
                metadata
              }
              orders {
                id
                number
                sequence
                status
                metadata
                created_at
                customer {
                  id
                  name
                  address {
                    id
                    city
                  }
                }
                units {
                  number
                  type
                }
              }
            }
            total_percentage
          }
        }
      `;
      return api(query, 'shipment').then(({ data }) => {
        const { shipment } = data;
        return shipment;
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DETAIL_DATA_SUMMARY');
      });
    },
    LOAD_ORDERS({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const shipmentId = state.detailDataId;
      const query = `
        {
          orders(shipment_id: ${shipmentId}) {
            id
            number
            sequence
            metadata
            created_at
            updated_at
            destination {
              id
              code
              name
            }
            customer {
              external_id
              name
              address {
                city
                state
                country
                zip_code
                address1
                address2
              }
            }
            confirmations {
              key
              name
              signature
              created_at
              metadata
            }
            units {
              number
              type
            }
            external_id
          }
        }
      `;
      // commit('CLEAR_ORDER_DATA');
      commit('SET_DATA_STATE_SHIPMENT_ORDERS', 'LOADING');
      return api(query, 'orders').then(({ data }) => {
        const { orders } = data;
        state.orders.splice(0);
        orders.forEach((order) => {
          commit('ADD_ORDER_DATA_ON_LIST', order);
        }, this);
      }).then(() => {
        setTimeout(() => commit('SET_DATA_STATE_SHIPMENT_ORDERS', 'LOADED'), 1e3);
      }).catch(() => {
        commit('SET_DATA_STATE_SHIPMENT_ORDERS', 'ERROR');
      });
    },
    LOAD_LOCATIONS({ commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const query = `
      {
        locations {
          id
          name
          company {
            id
            name
          }
        }
      }
      `;

      return api(query, 'locations').then(({ data }) => {
        const { locations } = data;
        commit('ADD_LOCATIONS_DATA', locations);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_LOCATIONS');
      });
    },
    LOAD_VEHICLES({ commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const query = `
      {
        vehicles {
          id
          reg_no
          company {
            id
            name
          }
        }
      }
      `;

      return api(query, 'vehicles').then(({ data }) => {
        const { vehicles } = data;
        commit('ADD_VEHICLE_DATA', vehicles);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_VEHICLES');
      });
    },
    LOAD_LOADERS({ commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const query = `
      {
        loaders: employees(type: LOADER) {
          id
          name
          company {
            id
          }
          user {
            id
            username
            full_name
          }
        }
      }`;

      return api(query, 'loaders').then(({ data }) => {
        const { loaders } = data;
        commit('ADD_LOADERS_DATA', loaders);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_LOADERS');
      });
    },
    LOAD_DRIVERS({ commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const query = `
      {
        drivers: employees(type: DRIVER) {
          id
          name
          metadata
        }
      }`;

      return api(query, 'drivers').then(({ data }) => {
        const { drivers } = data;
        commit('ADD_DRIVERS_DATA', drivers);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DRIVERS');
      });
    },
    UPDATE_DATA({ state, commit, rootState }, payloads) {
      let { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const {
        origin,
        company,
        vehicle,
        loader,
        driver_id,
        metadata,
        number,
        orders,
        delivery_date,
      } = payloads;

      const metadataUpdate = metadata || {};
      if (Object.prototype.hasOwnProperty.call(metadataUpdate, 'loader_id')) {
        if (metadataUpdate.loader_id) {
          metadataUpdate.loader_id = parseInt(loader.id, 10);
        }
      }

      if (Object.prototype.hasOwnProperty.call(payloads, 'id')) {
        detailDataId = payloads.id;
      }

      const variables = {
        id: detailDataId,
        input: {
          number,
          update_meta: metadataUpdate,
        },
      };

      if (Object.prototype.hasOwnProperty.call(payloads, 'type')) {
        variables.input.type = payloads.type;
      }

      if (!isEmpty(driver_id)) {
        variables.input.driver_id = driver_id;
      }
      if (!isEmpty(origin)) {
        variables.input.origin_id = origin.id;
      }
      if (!isEmpty(company)) {
        variables.input.company_id = company.id;
      }
      if (!isEmpty(vehicle)) {
        variables.input.vehicle_id = vehicle.id;
      }
      if (!isEmpty(orders)) {
        variables.input.order_ids = orders;
      }
      if (!isEmpty(delivery_date)) {
        variables.input.delivery_date = delivery_date;
      }

      const query = `
        mutation CreateUpdateShipment($id: ID!, $input: ShipmentUpdateInput) {
          shipment: update_shipment(id: $id, input: $input) {
            id
            number
            state
            type
            metadata
            created_at
            updated_at
            external_id
            company {
              id
              name
            }
            origin {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
            }
            vehicle {
              id
              reg_no
              company {
                name
              }
              driver {
                name
              }
            }
            metadata
            created_at
          }
        }
      `;
      return api({
        query,
        variables,
      }, 'update_shipment').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.shipment);
      }).catch(() => {
        commit('ADD_ERROR', 'UPDATE_DATA');
      });
    },
    CREATE_DATA({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const {
        origin,
        company,
        vehicle,
        loader,
        orders,
        number,
        driver_id,
        delivery_date,
        metadata,
      } = payloads;

      const variables = {
        input: {
          number,
          driver_id,
          delivery_date,
        },
      };

      if (Object.prototype.hasOwnProperty.call(payloads, 'type')) {
        variables.input.type = payloads.type;
      }

      if (Object.prototype.hasOwnProperty.call(payloads, 'state')) {
        variables.input.state = payloads.state;
      }

      if (!isEmpty(origin)) {
        variables.input.origin_id = origin.id;
      }
      if (!isEmpty(company)) {
        variables.input.company_id = company.id;
      }
      if (!isEmpty(vehicle)) {
        variables.input.vehicle_id = vehicle.id;
      }
      if (!isEmpty(orders)) {
        variables.input.orders = orders.reduce((newArr, order) => {
          const pushArr = {
            number: order.number,
            company_id: company.id,
            customer_id: order.customer.id,
            destination_id: order.destination.id,
            units: order.units,
            delivery_date,
            type: order.type,
          };
          if (Object.prototype.hasOwnProperty.call(order, 'id')) {
            pushArr.id = order.id;
          }
          newArr.push(pushArr);
          return newArr;
        }, []);
      }
      if (!isEmpty(loader)) {
        variables.input.metadata = {
          loader_id: loader.id,
        };
      }
      if (Object.prototype.hasOwnProperty.call(variables.input, 'metadata')) {
        variables.input.metadata.delivery_time = get(metadata, 'delivery_time');
      } else {
        variables.input.metadata = {
          delivery_time: get(metadata, 'delivery_time'),
        };
      }
      const query = `
        mutation CreateUpdateShipment($input: ShipmentCreateInput) {
          shipment: create_shipment(input: $input) {
            id
            number
            state
            type
            metadata
            created_at
            updated_at
            external_id
            company {
              id
              name
            }
            origin {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
            }
            vehicle {
              id
              reg_no
              company {
                name
              }
              driver {
                name
              }
            }
            metadata
            created_at
          }
        }
      `;
      return api({
        query,
        variables,
      }, 'create_shipment').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.shipment);
        return data.shipment;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_DATA');
      });
    },
    CREATE_DUMMY_SHIPMENT({ rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const query = `
        mutation {
          shipment: create_shipment_from_template
          (
            name: "ON_CALL_TRUCK",
            delivery_date: "${payloads.deliveryDate}",
            plate_no: "${payloads.plateNo}",
            type_full: "${payloads.typeFull}",
            type_short: "${payloads.typeShort}",
            type: "${payloads.type}",
            max_volume: ${parseFloat(payloads.maxVolume)},
            max_weight: ${parseFloat(payloads.maxWeight)}
          ) {
            id
          }
        }
      `;
      return api({ query }, 'create_dummy_shipment');
    },
    CREATE_COPP_SCHEDULE({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const {
        vehicle,
        number,
        delivery_date,
        metadata,
      } = payloads;

      const variables = {
        input: {
          number,
          delivery_date,
        },
      };

      if (!isEmpty(vehicle)) {
        variables.input.vehicle_id = vehicle.id;
      }
      if (Object.prototype.hasOwnProperty.call(variables.input, 'metadata')) {
        variables.input.metadata.delivery_time = get(metadata, 'delivery_time');
        variables.input.metadata.vehicle_group = get(metadata, 'vehicle_group');
      } else {
        variables.input.metadata = {
          delivery_time: get(metadata, 'delivery_time'),
          vehicle_group: get(metadata, 'vehicle_group'),
        };
      }
      const query = `
        mutation CreateSchedule($input: ShipmentScheduleCreateInput) {
          shipment: create_copp_schedule(input: $input) {
            id
            number
            state
            type
            metadata
            created_at
            updated_at
            external_id
            company {
              id
              name
            }
            origin {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
            }
            vehicle {
              id
              reg_no
              company {
                name
              }
              driver {
                name
              }
            }
            metadata
            created_at
          }
        }
      `;
      return api({
        query,
        variables,
      }, 'create_shipment').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.shipment);
        return data.shipment;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_DATA');
      });
    },
    ADD_ORDER({ state, rootState, commit }, payloads) {
      let { detailDataId: shipmentId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const { order_id: orderId, shipment_id } = payloads;

      if (shipment_id) shipmentId = shipment_id;

      const mutation = `mutation {
        added: add_shipment_order(shipment_id: ${shipmentId}, order_id: ${orderId}) {
          id
          number
        }
      }`;

      return api(mutation, 'add_shipment_order').catch(() => {
        commit('ADD_ERROR', 'ADD_ORDER');
      });
    },
    DELETE_DATA({ state, commit, rootState }, shipmentId) {
      const id = !shipmentId ? state.detailDataId : shipmentId;
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const mutation = `mutation {
        deleted: delete_shipment(id: ${id})
      }`;

      return api(mutation, 'delete_shipment').then(({ data }) => {
        const deleteOk = data.deleted;
        if (deleteOk) commit('DELETE_DETAIL_DATA', id);
        return deleteOk;
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_DATA');
      });
    },
    FREE_SEARCH_DATA({ rootState, commit }, querySearch) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { value } = querySearch;
      const query = `{
        shipments: find_shipments_summary(query: "${value}") {
          id
          number
        }
      }`;
      return api(query, 'search_shipments').catch(() => {
        commit('ADD_ERROR', 'FREE_SEARCH_DATA');
      });
    },
    LOAD_DAILY_SHIPMENTS({ rootState, commit }, payloads) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { start_date, end_date } = payloads;
      const query = `{
        daily_shipments(
          start_date: "${start_date}"
          end_date: "${end_date}"
        ) {
          date
          count
          percentage
        }
      }`;
      return api(query, 'daily_shipments').then(({ data }) => data.daily_shipments).catch(() => {
        commit('ADD_ERROR', 'LOAD_DAILY_SHIPMENTS');
      });
    },
    SHIPMENT_BY_STATE({ rootState, commit }, payloads) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const {
        start_date, end_date, state_filter_or, use_delivery_date,
      } = payloads;

      let useDeliveryDateString = '';

      if (typeof use_delivery_date === 'boolean') {
        useDeliveryDateString = `use_delivery_date: ${use_delivery_date}`;
      }

      const query = `{
        shipment_by_state(
          start_date: "${start_date}"
          end_date: "${end_date}"
          state_filter_or: [${state_filter_or}]
          ${useDeliveryDateString}
        ) {
          detail_state {
            state
            count
            percentage
          }
          shipments {
            id
            number
            created_at
            delivery_date
            driver {
              id
              name
            }
            vehicle {
              id
              reg_no
            }
            state
            confirmations {
              id
              key
            }
            orders {
              confirmations {
                 id
              }
            }
          }
          date_range
        }
      }`;
      return api(query, 'shipment_by_state').then(({ data }) => data.shipment_by_state).catch(() => {
        commit('ADD_ERROR', 'SHIPMENT_BY_STATE');
      });
    },
    UPDATE_STATE_SHIPMENTS({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const {
        state_filter_or,
        id,
      } = payloads;
      const shipment_id = id;
      const variables = {
        in: {
          state: state_filter_or,
        },
      };
      const query = `mutation UpdateShipmentState($in: ShipmentUpdateInput) {
        ${shipment_id.map(val => `
          up${val}: update_shipment(id: ${val}, input: $in) {
            id
            state
            number
          }
        `).join('')}
      }`;
      return api({
        query,
        variables,
      }, 'update_shipment').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.shipment);
      }).catch(() => {
        commit('ADD_ERROR', 'UPDATE_DATA');
      });
    },
    UPDATE_STATE_SHIPMENT({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const {
        state_filter_or,
        id,
      } = payloads;
      const shipment_id = id;
      const variables = {
        id: shipment_id,
        in: {
          state: state_filter_or,
        },
      };
      const query = `mutation UpdateShipmentState($in: ShipmentUpdateInput) {
        update: update_shipment(id: $id, input: $in) {
          id
          state
          number
      }`;
      return api({
        query,
        variables,
      }, 'update_shipment').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.shipment);
      }).catch(() => {
        commit('ADD_ERROR', 'UPDATE_DATA');
      });
    },
    UPDATE_SHIPMENT_STATE({ rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const {
        state,
        id,
      } = payloads;
      const shipment_id = id;
      const variables = {
        id: shipment_id,
        in: {
          state,
        },
      };
      const query = `mutation UpdateShipmentState($id: ID!, $in: ShipmentUpdateInput!) {
        update: update_shipment(id: $id, input: $in) {
          id
          state
          number
        }
      }`;
      return api({ query, variables }, 'update_shipment_state');
    },
    FIND_SHIPMENTS_BY_RELATED_ORDER({ rootState, commit }, payloads) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const shipmentNumber = createInputParam(payloads, 'shipment_number');
      const orderNumber = createInputParam(payloads, 'order_number');
      const customerName = createInputParam(payloads, 'customer_name');
      const startDate = createInputParam(payloads, 'start_date');
      const endDate = createInputParam(payloads, 'end_date');
      const { limit, offset } = payloads;
      const query = `{
        data: find_shipments_by_related_order(
          ${shipmentNumber}
          ${orderNumber}
          ${customerName}
          ${startDate}
          ${endDate}
          limit: ${limit}
          offset: ${offset}
        ) {
          count
          rows {
            id
            number
            type
            state
            metadata
            created_at
            updated_at
            external_id
            driver {
              id
              name
            }
            origin {
              id
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
              metadata
            }
            vehicle {
              id
              reg_no
              company {
                id
                name
              }
              driver {
                id
                name
              }
            }
            driver {
              id
              name
            }
            confirmations {
              key
              name
              created_at
            }
          }
        }
      }`;

      return api(query, 'shipments_by_related_order').then(({ data }) => {
        commit('CLEAR_SHIPMENTS_RESULT_DATA');
        const { data: resultData } = data;
        resultData.rows.forEach((result) => {
          commit('ADD_SHIPMENTS_RESULT', result);
        });
        commit('SET_SHIPMENTS_RESULT_COUNT', resultData.count);
        return resultData;
      }).catch(() => {
        commit('ADD_ERROR', 'SHIPMENT_BY_RELATED_ORDER');
      });
    },
    LOAD_SHIPMENTS_SUMMARY_BY_RANGE_DATE({ state, rootState, commit }, payloads) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const companyId = createInputParam(state.query, 'company_id', false);
      const originId = createInputParam(state.query, 'origin_id', false);
      const vehicleId = createInputParam(state.query, 'vehicle_id', false);
      let after = '';
      let before = '';

      const {
        limit,
        after: lastData,
        sort_direction: direction,
        sort_by: by,
        confirmation_filter_or: confirmFilter,
        state_filter_or: stateFilter,
        start_date,
        end_date,
        filter_by_delivery_date,
      } = payloads;

      const stateValue = !isEmpty(stateFilter) ?
        `state_filter_or: [${stateFilter.join(', ')}]` : '';
      const confirmationValue = !isEmpty(confirmFilter) ?
        `confirmation_filter_or: [${confirmFilter.join(', ')}]` : '';
      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      let skip = '';
      if (lastData !== null && lastData) {
        skip = `
          skip: {
            by: CREATED_AT
            ${after}
            ${before}
          },
        `;
      }
      let limitString = '';
      let startDateString = '';
      let endDateString = '';
      let filterByDeliveryString = '';

      if (limit !== null && limit) {
        limitString = `limit: ${limit}`;
      }
      if (start_date !== null && start_date) {
        startDateString = `start_date: "${start_date}"`;
      }
      if (end_date !== null && end_date) {
        endDateString = `end_date: "${end_date}"`;
      }
      if (typeof filter_by_delivery_date === 'boolean') {
        filterByDeliveryString = `filter_by_delivery_date: ${filter_by_delivery_date}`;
      }

      const query = `
        {
          summary: shipments_summary(
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${startDateString}
            ${endDateString}
            ${limitString}
            ${skip}
            ${companyId}
            ${originId}
            ${vehicleId}
            ${confirmationValue}
            ${stateValue}
            ${filterByDeliveryString}
          ) {
            id
            number
            delivery_date
            origin {
              id
              code
              name
              metadata
            }
            company {
              id
              name
            }
            vehicle {
              id
              reg_no
              metadata
              company {
                id
                name
              }
              driver {
                id
                name
              }
              gps_devices {
                id
                number
                gps_info {
                  id
                  longitude
                  latitude
                  road_name
                }
              }
            }
            driver {
              id
              name
            }
            destinations {
              name
              address
              percentage
              finish
              total_order
              direction {
                id
                distance
                duration
                metadata
              }
              orders {
                id
                number
                sequence
                status
                metadata
                created_at
                customer {
                  id
                  name
                  address {
                    id
                    city
                  }
                }
                units {
                  number
                  type
                }
              }
            }
            metadata
            total_percentage
            updated_at
            created_at
          }
        }
      `;
      return api(query, 'load_shipments_summary_by_range_date').then(({ data }) => {
        const { summary } = data;
        return summary;
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_SHIPMENTS_SUMMARY_BY_RANGE_DATE');
      });
    },
    LOAD_SHIPMENT_DESTINATIONS({ rootState }, payloads) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { shipment_id: shipmentId } = payloads;
      const query = `
        {
          summary: shipments_summary(shipment_id: ${shipmentId}) {
            number
            origin {
              code
              name
              latitude
              longitude
              geometry {
                type
                coordinates
              }
              metadata
            }
            destinations {
              customer {
                name
              }
              orders {
                sequence
                destination {
                  code
                  name
                  latitude
                  longitude
                  geometry {
                    type
                    coordinates
                  }
                  metadata
                }
                direction {
                  geo_poly {
                    type
                    coordinates
                  }
                }
              }
              percentage
            }
          }
        }
      `;
      return api(query, 'shipment_destinations').then(({ data }) => {
        const { summary } = data;
        return !isEmpty(summary)
          ? summary.pop()
          : [];
      });
    },
    LOAD_SHIPMENTS_BY_RANGE_DATE({ rootState, commit }, payloads) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const {
        start_date,
        end_date,
        state_filter_or: stateFilter,
        filter_by_delivery_date,
      } = payloads;

      let filterByDeliveryString = '';

      if (typeof filter_by_delivery_date === 'boolean') {
        filterByDeliveryString = `filter_by_delivery_date: ${filter_by_delivery_date}`;
      }

      const stateValue = !isEmpty(stateFilter) ?
        `state_filter_or: [${stateFilter.join(', ')}]` : '';
      const query = `{
        shipments(
          start_date: "${start_date}"
          end_date: "${end_date}"
          ${stateValue}
          ${filterByDeliveryString}
        ) {
          id
          number
          type
          state
          delivery_date
          vehicle {
            id
            reg_no
            metadata
            company {
              id
              name
            }
            driver {
              id
              name
            }
            groups {
              id
              name
              description
            }
          }
          driver {
            id
            name
          }
          orders {
            id
            number
            company {
              name
              id
            }
            metadata
            customer {
              id
              external_id
              name
              address {
                address1
                address2
                city
                country
                state
                zip_code
              }
            }
            sequence
            destination {
              id
              code
              name
              metadata
            }
          }
          origin {
            id
            code
            name
            latitude
            longitude
            geometry {
              type
              coordinates
            }
            metadata
          }
          confirmations {
            key
            name
            created_at
          }
          metadata
        }
      }`;
      return api(query, 'load_shipments_by_range_date')
        .then(({ data }) => data.shipments)
        .catch(() => {
          commit('ADD_ERROR', 'LOAD_SHIPMENTS_BY_RANGE_DATE');
        });
    },
    LOAD_SHIPMENTS_BY_RANGE_DATE2({ rootState, commit }, payloads) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const {
        start_date,
        end_date,
        state_filter_or: stateFilter,
        filter_by_delivery_date,
      } = payloads;

      let filterByDeliveryString = '';

      if (typeof filter_by_delivery_date === 'boolean') {
        filterByDeliveryString = `filter_by_delivery_date: ${filter_by_delivery_date}`;
      }

      const stateValue = !isEmpty(stateFilter) ?
        `state_filter_or: [${stateFilter.join(', ')}]` : '';
      const query = `{
        shipments(
          start_date: "${start_date}"
          end_date: "${end_date}"
          ${stateValue}
          ${filterByDeliveryString}
        ) {
          id
          number
          type
          state
          delivery_date
          vehicle {
            id
            reg_no
            metadata
          }
          driver {
            id
            name
          }
          orders {
            id
          }
          confirmations {
            key
            name
            created_at
          }
          metadata
        }
      }`;
      return api(query, 'load_shipments_by_range_date')
        .then(({ data }) => data.shipments)
        .catch(() => {
          commit('ADD_ERROR', 'LOAD_SHIPMENTS_BY_RANGE_DATE');
        });
    },
    LOAD_TODAY_SHIPMENTS({ rootState, commit }, today) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const query = `{
        shipments(
          start_date: "${today}"
          end_date: "${today}"
        ) {
          id
          number
          delivery_date
          metadata
          type
          driver {
            id
            name
          }
          vehicle {
            id
            reg_no
            driver {
              name
            }
          }
          orders {
            id
          }
          state
        }
      }`;
      return api(query, 'load_today_shipments')
        .then(({ data }) => data.shipments)
        .catch(() => {
          commit('ADD_ERROR', 'LOAD_TODAY_SHIPMENTS');
        });
    },
    ADD_SHIPMENT_ORDER: async ({ rootState, commit }, payloads) => {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const { order_id: orderId, shipment_id: shipmentId } = payloads;
      const mutation = `mutation {
        added: add_shipment_order(shipment_id: ${shipmentId}, order_id: ${orderId}) {
          id
          number
          orders {
            id
            number
            metadata
          }
        }
      }`;

      return api(mutation, 'add_shipment_order').catch(() => {
        commit('ADD_ERROR', 'ADD_SHIPMENT_ORDER');
      });
    },
    REMOVE_SHIPMENT_ORDER({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const { order_id: orderId, shipment_id: shipmentId } = payloads;
      const mutation = `mutation {
        removed: remove_shipment_order(shipment_id: ${shipmentId}, order_id: ${orderId}) {
          id
          number
          orders {
            id
            number
          }
        }
      }`;

      return api(mutation, 'remove_shipment_order').catch(() => {
        commit('ADD_ERROR', 'REMOVE_SHIPMENT_ORDER');
      });
    },
    REMOVE_VEHICLE_SHIPMENT({ rootState, commit }, shipmentId) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const mutation = `mutation {
        removed: remove_vehicle_shipment(id: ${shipmentId})
      }`;

      return api(mutation, 'remove_vehicle_shipment').catch(() => {
        commit('ADD_ERROR', 'REMOVE_VEHICLE_SHIPMENT');
      });
    },
    RECALCULATE_SHIPMENT_ROUTE({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const { shipment_id: shipmentId } = payloads;
      const mutation = `mutation {
        shipment: recalculate_shipment_route(id: ${shipmentId}) {
          id
          number
          orders {
            id
            number
          }
        }
      }`;

      return api(mutation, 'recalculate_shipment_route').catch(() => {
        commit('ADD_ERROR', 'RECALCULATE_SHIPMENT_ROUTE');
      });
    },
    CALCULATE_SHIPMENT_ROUTE({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const mutation = `mutation {
        shipment: create_shipment_by_order_route(delivery_date: "${payloads.delivery_date}") {
          id
          number
          orders {
            id
            number
          }
        }
      }`;

      return api(mutation, 'create_shipment_by_order_route').catch(() => {
        commit('ADD_ERROR', 'CALCULATE_SHIPMENT_ROUTE');
      });
    },
    MOVE_SHIPMENT_ORDER({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const {
        source_shipment_id: sourceShipmentId,
        target_shipment_id: targetShipmentId,
        order_id: orderId,
      } = payloads;

      let removeMutation = '';
      if (sourceShipmentId) {
        removeMutation = `
          remove_shipment_order(shipment_id: ${sourceShipmentId}, order_id: ${orderId}) {
            id
            number
            orders {
              id
              number
            }
          }
        `;
      }

      const mutation = `mutation {
        ${removeMutation}
        add_shipment_order(shipment_id: ${targetShipmentId}, order_id: ${orderId}) {
          id
          number
          orders {
            id
            number
          }
        }
      }`;

      return api(mutation, 'move_shipment_order').catch(() => {
        commit('ADD_ERROR', 'MOVE_SHIPMENT_ORDER');
      });
    },
    SET_MULTIPLE_SHIPMENT_ORDERS({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');

      const mutation = `mutation {
        set_multiple_shipment_orders(data: ${JSON.stringify(JSON.stringify(payloads))})
      }`;

      return api(mutation, 'set_multiple_shipment_orders');
    },
    EXPORT_PRAMBANAN_SHIPMETS({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const { startDate, endDate } = payloads;
      const query = `{
        export_prambanan_route(start_date: "${startDate}", end_date: "${endDate}", use_delivery_date: true) {
          file
          desc
        }
      }`;

      return api(query, 'export_prambanan_shipments')
        .then(({ data }) => data.export_prambanan_route)
        .catch(() => {
          commit('ADD_ERROR', 'EXPORT_PRAMBANAN_SHIPMETS');
        });
    },
    EXPORT_PRAMBANAN_COMPLETION({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const { startDate, endDate, useDeliveryDate } = payloads;
      const query = `{
        export_prambanan_completion(
          start_date: "${startDate}",
          end_date: "${endDate}",
          use_delivery_date: ${useDeliveryDate}
        ) {
          file
          desc
        }
      }`;
      return api(query, 'export_prambanan_completion')
        .then(({ data }) => data.export_prambanan_completion)
        .catch(() => {
          commit('ADD_ERROR', 'EXPORT_PRAMBANAN_COMPLETION');
        });
    },
    LOAD_SHIPMENT_SUMMARIES({ rootState }, payloads) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { shipment_ids: shipmentIds } = payloads;

      const query = `{
        ${shipmentIds.map(id => `
          summary_${id}: shipment_summary2(id: ${id}) {
            id
            number
            metadata
            driver {
              id
              name
            }
            steps {
              type
              job
              distance
              duration
              arrival
              childs
              location
            }
            deliveries {
              id
              name
              customer {
                name
              }
              direction {
                id
                distance
                duration
                geo_poly {
                  type
                  coordinates
                }
                origin {
                  code
                  name
                  latitude
                  longitude
                }
                destination {
                  code
                  name
                  latitude
                  longitude
                  metadata
                }
              }
            }
            orders {
              id
              number
              sequence
              metadata
              customer {
                id
                external_id
                name
                address {
                  address1
                  address2
                  city
                  country
                  state
                  zip_code
                }
              }
              destination {
                id
                code
                name
              }
            }
            vehicle {
              id
              reg_no
              metadata
            }
          }
        `)}
      }`;

      return api(query, 'shipment_summaries').then(({ data }) => data);
    },
    RESTART_SHIPMENT_DATA({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const { start_date, end_date, delete_order = true } = payloads;

      const mutation = `
        mutation {
          delete_orders_by_date_range(start_date: "${start_date}" end_date: "${end_date}" use_delivery_date: true)
          delete_shipment_by_date_range(start_date: "${start_date}" end_date: "${end_date}" use_delivery_date: true)
        }
      `;

      return api(mutation, 'restart_shipment_data').catch(() => {
        commit('ADD_ERROR', 'RESTART_SHIPMENT_DATA');
      });
    },
    RESET_CALCULATED_ROUTE_DATA({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const { start_date, end_date } = payloads;

      const mutation = `
        mutation {
          delete_shipment_by_date_range(start_date: "${start_date}" end_date: "${end_date}" use_delivery_date: true)
          create_shipment_by_order_route(delivery_date: "${start_date}") {
            id
            number
          }
        }
      `;

      return api(mutation, 'reset_calculated_route_data').catch(() => {
        commit('ADD_ERROR', 'RESET_CALCULATED_ROUTE_DATA');
      });
    },
    LOAD_ROUTING_SUMMARY({ rootState, commit }, payloads) {
      const { token } = rootState;
      const api = tmsApi.buildRetry(token, 'shipment_md');
      const { start_date, end_date, filter_by_delivery_date } = payloads;

      let filterByDeliveryString = '';

      if (typeof filter_by_delivery_date === 'boolean') {
        filterByDeliveryString = `filter_by_delivery_date: ${filter_by_delivery_date}`;
      }

      const query = `{
        summary: routing_summary(start_date: "${start_date}", end_date: "${end_date}", ${filterByDeliveryString}) {
          type
          count
          orders {
            id
            number
            company {
              name
              id
            }
            metadata
            customer {
              id
              external_id
              name
              address {
                address1
                address2
                city
                country
                state
                zip_code
              }
            }
            sequence
            shipment {
              state
            }
            destination {
              id
              code
              name
              metadata
            }
          }
        }
      }`;

      return api(query, 'routing_summary')
        .then(({ data }) => data.summary)
        .catch(() => {
          commit('ADD_ERROR', 'LOAD_ROUTING_SUMMARY');
        });
    },
    GET_CANCELATION_ORDERS({ rootState, commit }, payloads) {
      const api = tmsApi.buildRetry(rootState.token, 'shipment_md');
      const { start_date: startDate, end_date: endDate } = payloads;
      const query = `
        {
          orders_canelation (start_date: "${startDate}", end_date: "${endDate}") {
            shipment_deliveries {
              id
              number
              state
              vehicle {
                reg_no
              }
              driver {
                name
              }
              metadata
            }
            cancelation_orders {
              id
              number
              metadata
              shipment {
                driver {
                  name
                }
                vehicle {
                  reg_no
                }
                metadata
              }
            }
          }
        }`;

      return api(query, 'get_cancelation_orders').then(({ data }) => {
        const { orders_canelation = {} } = data;
        return orders_canelation;
      }).catch(() => {
        commit('ADD_ERROR', 'GET_CANCELATION_ORDERS');
      });
    },
    DELETE_CONFIRMATION_DRIVER({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const id = payloads.driver_confirm_id;
      const query = `mutation {
        ${id.map(val => `
          del${val}: delete_confirmation(id: ${val})
        `).join('')}
      }`;
      return api({
        query,
      }, 'delete_confirmation')
        .then(({ data }) => data)
        .catch(() => {
          commit('ADD_ERROR', 'DELETE_CONFIRMATION');
        });
    },
    DELETE_CONFIRMATION_ORDER({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const id = payloads.order_confirm_id;
      const query = `mutation {
        ${id.map(val => `
          del${val}: delete_confirmation(id: ${val})
        `).join('')}
      }`;
      return api({
        query,
      }, 'delete_confirmation')
        .then(({ data }) => data)
        .catch(() => {
          commit('ADD_ERROR', 'DELETE_CONFIRMATION');
        });
    },
    DELETE_CONFIRMATION_LOADER({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const id = payloads.loader_confirm_id;
      const query = `mutation {
        ${id.map(val => `
          del${val}: delete_confirmation(id: ${val})
        `).join('')}
      }`;
      return api({
        query,
      }, 'delete_confirmation')
        .then(({ data }) => data)
        .catch(() => {
          commit('ADD_ERROR', 'DELETE_CONFIRMATION');
        });
    },
    SWITCH_SHIPMENT_VEHICLE({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token, 'shipment_md');
      const { source_shipment_id, target_shipment_id } = payloads;

      const mutation = `
        mutation {
          switch_shipment_vehicle(source_shipment_id: ${source_shipment_id}, target_shipment_id: ${target_shipment_id}) {
            id
            number
          }
        }
      `;

      return api(mutation, 'switch_shipment_vehicle').catch(() => {
        commit('ADD_ERROR', 'SWITCH_SHIPMENT_VEHICLE');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/shipment_md/shipments.js